module.exports = __webpack_public_path__ + "75481490b03c567d202d4ceead1e5411.svg";